const COMMON = "https://bk.collegeclue.in/";
// const COMMON = "http://localhost:4000/";
const URL_ENUM = {
  LEAD: COMMON + "admin/lead",
  BLOGS: COMMON + "admin/blog",
  LOGIN: COMMON + "admin/login",
  BATCH: COMMON + "admin/batch",
  REVIEWS: COMMON + "admin/review",
  PARTNER: COMMON + "admin/partner",
  STUDENTS: COMMON + "admin/student",
  ADD_NEW_EXAM: COMMON + "admin/exam",
  VEIRY: COMMON + "university/verify",
  ADD_REVIEW: COMMON + "admin/review",
  COACHING: COMMON + "admin/coaching",
  ADDLISTING: COMMON + "admin/listing",
  SUBADMIN: COMMON + 'admin/sub-admin',
  CALL_REQUESTS: COMMON + "admin/expert",
  UNIVERITY: COMMON + "admin/university",
  ADD_NEW_COURSE: COMMON + "admin/course",
  INSTITUTE_PROD: COMMON + "admin/product",
  CUSTOM_PAGE: COMMON + "admin/custom-page",
  EXAM_ORDERS: COMMON + "admin/exam-orders",
  AVAILABLE_COURSES: COMMON + "admin/course",
  MBBS_ABROAD: COMMON + "common/generalJSON",
  CONFIG: COMMON + "university/configuration",
  COURSE_ORDERS: COMMON + "admin/course-orders",
  BATCH_ORDERS: COMMON + "admin/batch-orders",
  CONTACT_US: COMMON + "admin/studentContactUs",
  NEW_CONTACT_US: COMMON + "admin/contact-us",
  GROUP_LIST: COMMON + "common/collegeGroup/list",
  ALL_UNIV_LIST: COMMON + "admin/university-list",
  UPDATE_UNIVERSITY: COMMON + "admin/university/edit",
  COACHING_BY_TOKEN: COMMON + "coaching/access-token",
  UPDATE_COACHING_DATA: COMMON + "admin/coaching/edit",
  SIGNUP_REQUEST: COMMON + 'admin/register-university',
  UPLOAD_ON_S3: COMMON + "university/upload_data_on_s3",
  UNIVERISTY_BY_TOKEN: COMMON + "university/access-token",
  STUDENT_APPLICATION: COMMON + "admin/student-application",
  COACHING_SIGNUP_REQUEST: COMMON + 'admin/register-coaching',
};
export default URL_ENUM;
